module.exports = __webpack_public_path__ + "img/student.9d92cc42.svg";